import { render, staticRenderFns } from "./QueryExportModal.vue?vue&type=template&id=840a42d2"
import script from "./QueryExportModal.vue?vue&type=script&lang=js"
export * from "./QueryExportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports